import { useState, useEffect } from "react";
import {
  getDocumentsCount,
  getFirstData,
  getNextData,
} from "../config/firestore";
import { Loader } from "../components";
import { exportToExcel } from "../utils";
const Junoon = () => {
  const [regs, setRegs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [currentCount, setCurrentCount] = useState(0);
  const [sortBy, setSortBy] = useState("Band Name");
  const [order, setOrder] = useState("asc");
  const [searchBy, setSearchBy] = useState("Band Name");
  const [searchText, setSearchText] = useState("");
  const [lastDoc, setLastDoc] = useState("");

  const getAllRegs = async () => {
    setLoading(true);
    let { last, data } = await getFirstData(
      "junoon26",
      sortBy,
      order,
      searchBy,
      searchText
    );
    let count = await getDocumentsCount("junoon26");
    if (data != null) {
      setRegs(data);
      setCurrentCount(data.length);
      setTotalCount(count);
      setLastDoc(last);
    }
    setLoading(false);
  };

  const getNext = async () => {
    if (lastDoc != null) {
      let { last, data } = await getNextData(
        "junoon26",
        sortBy,
        order,
        lastDoc,
        searchBy,
        searchText
      );
      if (data != null) {
        setRegs([...regs, ...data]);
        setLastDoc(last);
        setCurrentCount(currentCount + data.length);
      }
    }
  };

  useEffect(() => {
    getAllRegs();
  }, [sortBy, order]);
  return (
    <div>
      <div className="bg-white fixed w-full left-0 pl-20 z-10">
        <div className="flex items-end mx-3 mb-2 justify-between">
          <div className="flex flex-col justify-end">
            <h2 className="text-xl font-bold my-2">Junoon</h2>
            <div className="flex items-end">
              <button
                className="btn btn-neutral mr-2"
                onClick={() => {
                  exportToExcel("junoon26");
                }}
              >
                Save as Excel
              </button>
              <label className="flex items-center gap-2 font-semibold mx-2">
                Entries: {currentCount}&nbsp;/&nbsp;{totalCount}
                <button
                  onClick={() => {
                    getNext();
                  }}
                  className="btn"
                >
                  Show More
                </button>
              </label>
            </div>
          </div>
          <div className="flex flex-1 items-end justify-end">
            <label className="form-control w-full max-w-40 mx-2">
              <div className="label">
                <span className="label-text">Sort by</span>
              </div>
              <select
                id="orderBy"
                value={sortBy}
                onChange={(e) => {
                  setSortBy(e.target.value);
                  setSearchBy(e.target.value);
                }}
                className="select select-bordered w-full max-w-40"
              >
                <option value={"Band Name"}>By Bandname</option>
                <option value={"event"}>By Event</option>
                <option value={"city"}>By City</option>
              </select>
            </label>
            <label className="form-control w-full max-w-40 mx-2">
              <div className="label">
                <span className="label-text">Order by</span>
              </div>
              <select
                value={order}
                onChange={(e) => {
                  setOrder(e.target.value);
                }}
                className="select select-bordered w-full max-w-40"
              >
                <option value={"asc"}>Ascending</option>
                <option value={"desc"}>Descending</option>
              </select>
            </label>

            <label className="form-control w-full max-w-52 mx-2">
              <div className="label">
                <span className="label-text">Search</span>
              </div>
              <input
                id="search"
                value={searchText}
                type="text"
                className="input input-bordered w-full max-w-xs"
                onChange={(e) => setSearchText(e.target.value.toUpperCase())}
                placeholder={`Search by ${searchBy}`}
              />
            </label>
            <button
              onClick={() => {
                getAllRegs();
              }}
              className="btn"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="overflow-x-auto pt-28">
          <table className="table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Band Name</th>
                <th>Event</th>
                <th>email</th>
                <th>Phone</th>
                <th>Alt. Phone</th>
                <th>City</th>
                <th>Submission</th>
                <th>Facebook</th>
                <th>Instagram</th>
                <th>Member1</th>
                <th>Member2</th>
                <th>Member3</th>
                <th>Member4</th>
                <th>Member5</th>
                <th>Member6</th>
                <th>Other</th>
              </tr>
            </thead>
            <tbody>
              {regs.map((reg, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{reg.data["Band Name"] || reg.data["Name"]}</td>
                    <td>{reg.data["Event"]}</td>
                    <td>
                      <a href={`mailto:${reg.data["Email Id"]}`}>{reg.data["Email Id"]}</a>
                    </td>
                    <td>{reg.data["Contact"]}</td>
                    <td>{reg.data["Alternate Number"]}</td>
                    <td>{reg.data["City"]}</td>
                    <td className="link">
                      <a target="_blank" rel="noreferrer" href={reg.data["Submission Link"]}>
                        {reg.data["Submission Link"]}
                      </a>
                    </td>
                    <td className="link">
                      <a target="_blank" rel="noreferrer" href={reg.data["Facebook Link"]}>
                        {reg.data["Facebook Link"]}
                      </a>
                    </td>
                    <td className="link">
                      <a target="_blank" rel="noreferrer" href={reg.data["Instagram Link"]}>
                        {reg.data["Instagram Link"]}
                      </a>
                    </td>
                    <td>{reg.data["Member Name 1"]}</td>
                    <td>{reg.data["Member Name 2"]}</td>
                    <td>{reg.data["Member Name 3"]}</td>
                    <td>{reg.data["Member Name 4"]}</td>
                    <td>{reg.data["Member Name 5"]}</td>
                    <td>{reg.data["Member Name 6"]}</td>
                    <td className="link">
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Junoon;
